import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Avatar from 'components/common/Avatar';
import FalconLightBox from 'components/common/FalconLightBox';
import FalconLightBoxGallery from 'components/common/FalconLightBoxGallery';
import Flex from 'components/common/Flex';
import { ChatContext } from 'context/Context';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { Col, Image, Row, Dropdown, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteMessage } from 'redux/chatSlice';
/* import ChatMessageOptions from './ChatMessageOptions'; */

const Message = ({ message, time, isHighlighted }) => {
  const user = message.user || message.client;
  const isLeft = !message.user;
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);

  const dispatch = useDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { getConversation, conversation } = useContext(ChatContext);
  const handleAvatarUrl = () => {
    if (user?.photo) {
      return user.photo.match(/http/)
        ? user.photo
        : `${process.env.REACT_APP_CLIENT}/uploads/clients/profile-pictures/${user.photo}`;
    }
  };
  const handleToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleDeleteMessage = async () => {
    await dispatch(deleteMessage(message.id));
    await getConversation(conversation.id);
    setOpenModal(false);
  };
  return (
    <Flex className={classNames('p-3', { 'd-block': !isLeft })}>
      {isLeft && (
        <Avatar
          size="l"
          className="me-2 mt-1"
          src={handleAvatarUrl()}
          name={`${user?.firstName} ${user?.lastName}`}
        />
      )}
      <div
        className={classNames('flex-1', {
          'd-flex justify-content-end': !isLeft
        })}
      >
        <div
          className={classNames('w-xxl-75', {
            'w-100': !isLeft
          })}
        >
          <Flex
            alignItems="center"
            className={classNames('hover-actions-trigger', {
              'flex-end-center': !isLeft,
              'align-items-center': isLeft
            })}
          >
            {/* {!isLeft && <ChatMessageOptions />} */}

            {message.attachments ? (
              <div className="chat-message chat-gallery">
                {message.text && (
                  <p
                    className="mb-0"
                    dangerouslySetInnerHTML={{
                      __html: message.text ? message.text : message
                    }}
                  />
                )}
                <FalconLightBoxGallery images={message.attachments}>
                  {setImgIndex => (
                    <Row className="mx-n1">
                      {message.attachments.map((img, index) => {
                        return (
                          <Col
                            xs={6}
                            md={4}
                            className="px-1"
                            style={{ minWidth: 50 }}
                            key={index}
                          >
                            <Image
                              fluid
                              rounded
                              className="mb-2 cursor-pointer"
                              src={img}
                              alt=""
                              onClick={() => setImgIndex(index)}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  )}
                </FalconLightBoxGallery>
              </div>
            ) : (
              <>
                <div
                  className={classNames('p-2 rounded-2 d-flex chat-message', {
                    'bg-200': isLeft,
                    'bg-primary text-white light': !isLeft
                  })}
                  style={{
                    boxShadow: isHighlighted
                      ? '0 0 0 0.3rem rgba(0, 123, 255, 0.35)'
                      : 'none'
                  }}
                >
                  {(message || message.message) && (
                    <p
                      className="mb-0"
                      dangerouslySetInnerHTML={{
                        __html: message.message ? message.message : message
                      }}
                    />
                  )}
                  {!message.client ? (
                    <>
                      <Dropdown
                        show={isDropdownOpen}
                        onClose={() => setIsDropdownOpen(false)}
                        onClick={handleToggle}
                      >
                        <Dropdown.Toggle
                          style={{
                            padding: '0',
                            color: 'black',
                            marginLeft: '10px'
                          }}
                          variant="link"
                          size="lg"
                          active={true}
                          id="dropdown-basic"
                        ></Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{ backgroundColor: 'crimson', padding: '0' }}
                        >
                          <Dropdown.Item onClick={handleOpenModal}>
                            Eliminar mensaje
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Modal
                        centered
                        show={openModal}
                        styles={{
                          modal: {
                            position: 'relative'
                          }
                        }}
                      >
                        <div style={{ position: 'relative', padding: '20px' }}>
                          <h4 className="mb-3">
                            Usted esta a punto de Eliminar Este Mensaje.
                          </h4>
                          <h4 className="mb-3">¿Desea Proseguir?</h4>
                          <div
                            className="d-flex justify-center"
                            style={{
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <button
                              className="btn btn-success h-1"
                              style={{
                                fontSize: '16px',
                                height: '50%',
                                marginRight: '1rem'
                              }}
                              onClick={handleDeleteMessage}
                            >
                              Confirmar
                            </button>
                            <button
                              onClick={() => setOpenModal(false)}
                              className="btn btn-danger ms-2"
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      </Modal>
                    </>
                  ) : (
                    ''
                  )}

                  {message.attachment && (
                    <FalconLightBox image={message.attachment}>
                      <Image
                        fluid
                        rounded
                        src={message.attachment}
                        width={150}
                        alt=""
                      />
                    </FalconLightBox>
                  )}
                </div>
              </>
            )}

            {/* {isLeft && <ChatMessageOptions />} */}
          </Flex>
          <div
            className={classNames('text-400 fs--2', {
              'text-end': !isLeft
            })}
          >
            {time.format('HH:mm')}

            {!isLeft && !!message.message && !!message.read_at && (
              <FontAwesomeIcon icon="check-double" className="text-success" />
            )}
          </div>
        </div>
      </div>
    </Flex>
  );
};
Message.propTypes = {
  message: PropTypes.object,
  time: PropTypes.object.isRequired,
  isGroup: PropTypes.bool,
  isHighlighted: PropTypes.bool
};

export default Message;
